import React from 'react';
import styled from 'styled-components';
import { Card, Typography } from '@material-ui/core';
import CardContent from '../../../common/card/CardContent';

const StyledTypography = styled(Typography)`
  margin-top: 0px;
  font-weight: 500;
`;

export interface JiraStatusCardProps {
  issue: any;
}

const JiraStatusCard: React.FC<JiraStatusCardProps> = ({ issue }) => {
  return (
    <Card>
      <CardContent background='primary'>
        <Typography variant='overline'>Status</Typography>
        <StyledTypography variant='h4'>In Progress</StyledTypography>
      </CardContent>
    </Card>
  );
};

export default JiraStatusCard;
